import type { KeyEventType } from "../types";
import { createProxies } from "./proxies";

type AxureTextBaseHandler = (id: number) => void;
type AxureTextHandler = (id: number) => boolean;
type AxureTextLocationHandler = (id: number, x: number, y: number) => boolean;
type AxureTextEditorKeyEventHandler = (id: number, eventType: KeyEventType, code: string, timestamp: number, modifiers: number) => Promise<boolean>;
type AxureSizeEventHandler = (id: number, width: number, height: number) => void;
export interface TextEditor {
  RightClick: AxureTextLocationHandler;
  TextChanged: AxureTextBaseHandler;
  TextInput: AxureTextHandler;
  UpdateRequested: AxureTextHandler;
  SelectionChanged: AxureTextHandler;
  PreviewGotFocus: AxureTextHandler;
  GotFocus: AxureTextHandler;
  PreviewLostFocus: AxureTextHandler;
  LostFocus: AxureTextHandler;
  KeyEvent: AxureTextEditorKeyEventHandler;
  BeforePaste: AxureTextHandler;
  ContentSynced: AxureTextBaseHandler;
  ContentSizeChanged: AxureSizeEventHandler;
}

export interface TextEditorExports {
  TextEditor: TextEditor;
}

export const {
  setup,
  rightClick,
  textChanged,
  textInput,
  updateRequested,
  selectionChanged,
  previewGotFocus,
  gotFocus,
  previewLostFocus,
  lostFocus,
  keyEvent,
  beforePaste,
  contentSynced,
  contentSizeChanged,
} = createProxies<TextEditor>([
  "RightClick",
  "TextChanged",
  "TextInput",
  "UpdateRequested",
  "SelectionChanged",
  "PreviewGotFocus",
  "GotFocus",
  "PreviewLostFocus",
  "LostFocus",
  "KeyEvent",
  "BeforePaste",
  "ContentSynced",
  "ContentSizeChanged",
]);
